<template>
  <div class="dbc-gc-form__field">
    <label class="dbc-gc-form__radiogroup-label">{{
      $t('dbc-label-payment-method')
    }}</label>
    <div class="c-payment-method c-radio-buttons">
      <div
        v-if="paymentMethods.includes('creditCard')"
        class="dbc-gc-form__radiogroup-element"
      >
        <input
          type="radio"
          id="creditCard"
          v-model="paymentMethod"
          value="creditcard"
          @change="changePaymentMethod"
          tabindex="0"
        />
        <label class="dbc-gc-form__radio-label" for="creditCard">
          {{ $t('dbc-label-creditcard') }}
          <div>
            <small>
              {{ $t('dbc-creditcard-verify-info') }}
            </small>
          </div>
        </label>
      </div>

      <div
        v-if="paymentMethods.includes('sepaDirectDebit')"
        class="dbc-gc-form__radiogroup-element"
      >
        <input
          type="radio"
          id="sepa"
          v-model="paymentMethod"
          value="sepa"
          @change="changePaymentMethod"
          tabindex="0"
        />
        <label class="dbc-gc-form__radio-label" for="sepa">
          {{ $t('dbc-label-sepa') }}
        </label>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  paymentMethods: string[]
}>()

const emit = defineEmits<{
  (e: 'changePaymentMethod'): void
}>()
const paymentMethod = useState('dbc-payment-method', () => 'creditcard')

function changePaymentMethod(event: any) {
  paymentMethod.value = event.target.value
  emit('changePaymentMethod')
}
</script>
